import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="bg-white py-16 sm:py-24 lg:py-32 overflow-hidden" data-id="element-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:items-center" data-id="element-12">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-13">
            <div className="mb-4 sm:mb-6 inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1 text-sm font-bold text-blue-600" data-id="element-14">
              <span className="h-2 w-2 rounded-full bg-blue-600 animate-pulse" data-id="element-15"></span>
              QUIÉNES SOMOS
            </div>
            <h2 className="mb-4 sm:mb-8 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight text-gray-900" data-id="element-16">
              40 años redefiniendo <br data-id="element-17" />
              <span className="text-blue-600" data-id="element-18">el estándar constructivo.</span>
            </h2>
            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg leading-relaxed text-gray-600 font-light" data-id="element-19">
              <p data-id="element-20">
                Forax no es solo una constructora; somos partners estratégicos
                en la materialización de tu visión corporativa. Con cuatro
                décadas de trayectoria, hemos evolucionado para ofrecer
                soluciones ágiles en un mercado que no se detiene.
              </p>
              <p className="hidden sm:block" data-id="element-21">
                Nos especializamos en habilitación de oficinas y retail,
                combinando la solidez de la experiencia con la flexibilidad de
                una startup. Entendemos tu operación y construimos espacios que
                funcionan desde el día uno.
              </p>
            </div>
          </motion.div>

          {/* Image with modern shape - Hidden on mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-22">
            <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-tr from-blue-100 to-indigo-50 opacity-70 blur-2xl" data-id="element-23" />
            <div className="relative aspect-[4/3] overflow-hidden rounded-[2rem] shadow-2xl shadow-blue-900/10" data-id="element-24">
              <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80&w=1200" alt="Equipo de Forax en obra corporativa" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-25" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 hidden md:flex items-center gap-4 rounded-2xl bg-white p-6 shadow-xl shadow-blue-900/10" data-id="element-26">
              <div className="flex -space-x-4" data-id="element-27">
                {[1, 2, 3].map(i => <div key={i} className="h-10 w-10 rounded-full border-2 border-white bg-gray-200" data-id="element-28" />)}
              </div>
              <div data-id="element-29">
                <p className="text-sm font-bold text-gray-900" data-id="element-30">
                  +500 Proyectos
                </p>
                <p className="text-xs text-gray-500" data-id="element-31">Ejecutados con éxito</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}